
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.2441 4.7559C9.91864 4.43047 9.91864 3.90283 10.2441 3.57739C10.5695 3.25195 11.0972 3.25195 11.4226 3.57739L17.2559 9.41072C17.5814 9.73616 17.5814 10.2638 17.2559 10.5892L11.4226 16.4226C11.0972 16.748 10.5695 16.748 10.2441 16.4226C9.91864 16.0971 9.91864 15.5695 10.2441 15.2441L14.6548 10.8333L3.33333 10.8333C2.8731 10.8333 2.5 10.4602 2.5 9.99998C2.5 9.53974 2.8731 9.16665 3.33333 9.16665L14.6548 9.16665L10.2441 4.7559Z","fill":"#00000"}})])
          )
        }
      }
    